import sponsorsData2024 from './2024'
import sponsorsData2025 from './2025'

import { SponsorCardInfo } from 'components/containers/Sponsors/SponsorCard'

export const sponsorsData: Record<number, SponsorCardInfo[]> = {
  2024: sponsorsData2024,
  2025: sponsorsData2025,
}
